import React from 'react';
import './notFound.styles.scss';

export const NotFoundPage = () => (
  <div>Nepostojeća stranica</div>
)